/**
 * Select
 */

import SlimSelect from "slim-select";
import $ from "jquery";
import Component, { nextTick } from "../../js/lib/component";
import Scrollbar from "../../js/lib/scrollbar";

export default class Select extends Component {
  init() {
    this.placeholder = this.$.root.data("placeholder") || "";
    this.valueWithPlaceholder =
      this.$.root.data("valueWithPlaceholder") || false;

    this.select = new SlimSelect({
      select: this.$.root.get(0),
      placeholder: this.placeholder,
      showSearch: false,
      allowDeselect: this.$.root.data("allowdeselect") || false,
      beforeOnChange: () => {
        const { singleSelected } = this.select.slim;
        const $placeholder = $(singleSelected.placeholder);

        if (this.valueWithPlaceholder) {
          $placeholder.css("opacity", 0);
        }

        if (this.get("stopPropagation")) {
          return false;
        }
      },
      onChange: info => {
        if (this.scrollbar) {
          this.scrollbar = null;
        }

        if (this.valueWithPlaceholder) {
          setTimeout(() => {
            const { singleSelected } = this.select.slim;
            const $placeholder = $(singleSelected.placeholder);

            if (info.text) {
              $placeholder.html(`<i>${this.placeholder}</i>: ${info.text}`);
            }

            $placeholder.css("opacity", 1);
          }, 0);
        }

        if (!this.get("stopPropagation")) {
          this.$.root.trigger("select:change");
        }
      }
      // beforeOpen: () => {
      //   if (!this.scrollbar) {
      //     const $list = $(this.select.slim.list);
      //     const $childs = $list.children();
      //     const $clone = $list.clone();

      //     $clone.html($childs);
      //     $list.replaceWith($clone);

      //     this.select.slim.list = $clone.get(0);
      //     this.scrollbar = Scrollbar.init(this.select.slim.list);
      //   }
      // },
      // afterClose: () => {
      //   if (this.scrollbar) {
      //     Scrollbar.destroy(this.scrollbar);
      //     this.scrollbar = null;
      //   }
      // }
    });

    const selectedOptions = this.$.root.get(0).selectedOptions;

    if (selectedOptions.length) {
      const value = selectedOptions[0].value;

      if (value) {
        this.$.root.one("change", e => {
          e.stopPropagation();
        });

        this.setValue(value);
      }
    }

    this.$.root.addClass("is-inited");
  }
  reset() {
    this.select.destroy();

    this.$.root.one("change", e => {
      e.stopPropagation();
    });

    this.$.root
      .removeAttr("data-value")
      .data("value", null)
      .find("option")
      .prop("selected", false)
      .removeAttr("selected");

    this.setValue("");

    nextTick().then(() => {
      this.init();
    });
  }
  getValue() {
    return this.$.root.val();
  }
  setValue(value) {
    this.set({ stopPropagation: true });
    this.select.set(value);
    nextTick().then(() => {
      this.set({ stopPropagation: false });
    });
  }
}

Component.mount(Select, {
  name: "Select",
  classList: {
    root: ".js-select"
  },
  state: {
    stopPropagation: false
  }
});
